export default "__VITE_ASSET__ZEjVf0mu__"